import React from 'react';
import { SetupAndOnboardingViewContainer } from '@jarvis/react-setup-and-onboarding-addons';
import { useAppTheme } from 'src/contexts/ThemeContext';
import { OnboardingStep } from 'src/types/onboardingStep';

type ConditionalSetupAndOnboardingViewContainerProps = {
  onboardingStep: OnboardingStep;
  children: React.ReactNode;
};

export const ConditionalSetupAndOnboardingViewContainer = ({
  onboardingStep,
  children
}: ConditionalSetupAndOnboardingViewContainerProps): JSX.Element => {
  const { isModal } = useAppTheme();

  if (isModal || onboardingStep == OnboardingStep.VALUE_PROPOSITION) {
    return <>{children}</>;
  }

  return (
    <SetupAndOnboardingViewContainer>
      {children}
    </SetupAndOnboardingViewContainer>
  );
};
